/*!
 * sceneHook.js — scene(): handed to whoever has the scenes
 * © 2026 Rob Canning — GPLv3
 *
 * A scene is a #$ block of the live console (liveScenes.js), so the console
 * runs scene(): it registers here, and the cue (cueDispatcher.js) asks. With
 * no console there are no scenes to go to: said, and nothing done.
 */

let runner = null;

/** The console's: (ast) => what it did. */
export function setSceneRunner(fn) { runner = typeof fn === "function" ? fn : null; }

export function handleSceneCue(ast) {
  if (!runner) {
    console.warn("[scene] a scene is a #$ block of the live console (#$ drop): open it to go to one");
    return null;
  }
  return runner(ast);
}
